module.exports = __webpack_public_path__ + "static/media/dashboard.97817c39.png";